
import {Notification} from "./models";
export default {
  name: "fixitno-snackbar",
  props: {
    snackbar: {
      type: [Notification, Object],
      required: true,
    },
  },
  methods: {
    closeSnackbar() {
      this.$emit("removeSnackbar", null);
    },
  },
  watch: {
    snackbar(a) {
      if (a.visible == true) {
        setTimeout(this.closeSnackbar, a.duration);
      }
    },
  },
  created(){
  }
};
